module.exports = "/_next/static/media/Image-5.14a673da.png";